export default {
  type: "Feature",
  properties: {
    name: "Партизан",
    location: [48.22589, 106.327],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [106.589750000562, 48.2453611115261],
        [106.61197222224, 48.2321666676576],
        [106.658444445255, 48.2375555564439],
        [106.676944444031, 48.2316666670831],
        [106.745111110789, 48.2278333338413],
        [106.763333333267, 48.2256388891235],
        [106.824333334116, 48.2161388889986],
        [106.875222222128, 48.1853611109266],
        [106.870083333179, 48.172722223252],
        [106.867250000187, 48.1426666664336],
        [106.85900000015, 48.1326666666334],
        [106.831277778447, 48.1043055548575],
        [106.841861110002, 48.0796388895232],
        [106.843583333304, 48.067583333604],
        [106.863250000087, 48.0226388887738],
        [106.856277778397, 47.9835833333042],
        [106.857540813258, 47.9825120950572],
        [106.863535003338, 47.9726257668657],
        [106.863573308162, 47.9724024508125],
        [106.863655095207, 47.9724000586158],
        [106.865055556369, 47.9700833330794],
        [106.867716653901, 47.9644307504788],
        [106.861782205784, 47.9559394470479],
        [106.862292612414, 47.9552005667528],
        [106.862435334823, 47.9549726551639],
        [106.862569934555, 47.9547454711267],
        [106.862529903932, 47.9545188581588],
        [106.86265762385, 47.9541586410085],
        [106.862643107893, 47.9540012209796],
        [106.862597375568, 47.9537379516452],
        [106.862200136028, 47.9532524103705],
        [106.862194166328, 47.9530734524779],
        [106.862301980652, 47.9529389165977],
        [106.862415842917, 47.9527951653646],
        [106.862789036385, 47.9524225123891],
        [106.860742861094, 47.9503349377073],
        [106.861957426994, 47.94974920746],
        [106.863148381193, 47.9491519452061],
        [106.863683759298, 47.9488378569816],
        [106.864261968515, 47.9485404242013],
        [106.865686168182, 47.9477861717945],
        [106.874055555919, 47.9439444442807],
        [106.874054129594, 47.9439365653203],
        [106.870944187624, 47.9419650841214],
        [106.870482681631, 47.9422265647042],
        [106.870157583905, 47.9423674390061],
        [106.869871586005, 47.9424582255667],
        [106.869292874067, 47.9428285582914],
        [106.869201645939, 47.9428649052912],
        [106.868988342038, 47.942911450603],
        [106.868501193675, 47.9430893266112],
        [106.867897545335, 47.9431534716554],
        [106.867768120303, 47.9431391715356],
        [106.867690392797, 47.9431416060004],
        [106.867652907256, 47.9431459479272],
        [106.867573068143, 47.9431144257901],
        [106.867182487182, 47.9431307781629],
        [106.866705822216, 47.9433542165239],
        [106.866274440813, 47.9435954866424],
        [106.865790007503, 47.9437804816839],
        [106.864752277096, 47.9439710192472],
        [106.864563335829, 47.9440760906391],
        [106.863703358223, 47.9443414508973],
        [106.863324570073, 47.9443904513583],
        [106.86296011082, 47.9443649411891],
        [106.862666666533, 47.9443611109766],
        [106.862455034472, 47.9442314862941],
        [106.860769827266, 47.9441517982669],
        [106.860784238002, 47.9433054849602],
        [106.861100953147, 47.9413139066115],
        [106.860540771739, 47.9408213569201],
        [106.859739796854, 47.939720721634],
        [106.859779993852, 47.938760287957],
        [106.859526555906, 47.9382159472083],
        [106.859292482162, 47.9380725943748],
        [106.858627977599, 47.9377923773164],
        [106.85862066791, 47.9377963253402],
        [106.858102266307, 47.9368014611186],
        [106.857552773342, 47.9361883330252],
        [106.857358936166, 47.9356396791279],
        [106.856829771477, 47.9351767072393],
        [106.855928470922, 47.9341880249575],
        [106.855780206891, 47.9335215841538],
        [106.855232161835, 47.932808097116],
        [106.854470400089, 47.9321014044563],
        [106.854395468576, 47.9318150144514],
        [106.854008001068, 47.9303030103757],
        [106.853806130249, 47.9292495049608],
        [106.853707788484, 47.9283080325897],
        [106.85361367623, 47.9276239920537],
        [106.853428982462, 47.9269113171037],
        [106.853428821483, 47.92690454341],
        [106.853428727054, 47.9269041791846],
        [106.853409091257, 47.9260785466876],
        [106.853327502962, 47.9257424889248],
        [106.85288958079, 47.9254619571037],
        [106.852722222353, 47.9242500001375],
        [106.852164040138, 47.9242329687765],
        [106.85199357904, 47.9230819723552],
        [106.851994371343, 47.9230819058054],
        [106.851993324532, 47.9230748344361],
        [106.852385194221, 47.9230417591699],
        [106.852450156749, 47.9226534768765],
        [106.852582163736, 47.9213129771123],
        [106.852815238333, 47.9196203972636],
        [106.853122572649, 47.9184750647724],
        [106.853215394375, 47.918028150279],
        [106.853191548851, 47.9178992045847],
        [106.853104518759, 47.9178303812672],
        [106.852750000612, 47.9176666668832],
        [106.852761846482, 47.9176651173514],
        [106.852749745205, 47.9176595289641],
        [106.854887595586, 47.9173799081563],
        [106.855035147354, 47.9173586409885],
        [106.854861111451, 47.9128611125503],
        [106.849492657061, 47.9124968709339],
        [106.845760550609, 47.9122187735776],
        [106.843711929162, 47.9120591978738],
        [106.840266958254, 47.9118023218198],
        [106.836744125841, 47.9115309801706],
        [106.832965373353, 47.9112428059108],
        [106.829613125246, 47.910978926836],
        [106.826238438153, 47.9107361170782],
        [106.821768920899, 47.9103857268199],
        [106.817842468255, 47.910073385978],
        [106.814180280496, 47.9097931545305],
        [106.811914381943, 47.9096104329752],
        [106.80722516391, 47.9096115139603],
        [106.805215064923, 47.9096312109117],
        [106.803047818402, 47.909645984075],
        [106.802737381425, 47.9096196438315],
        [106.80248036058, 47.9095716551079],
        [106.80229995388, 47.9095016509805],
        [106.802056052345, 47.9093858218982],
        [106.80175955486, 47.9092056076527],
        [106.801455287232, 47.9090206692685],
        [106.800973604049, 47.9087420871777],
        [106.80080165817, 47.9086927593634],
        [106.800327197442, 47.9086221634821],
        [106.799457777854, 47.9085421481017],
        [106.797681181541, 47.9084087039985],
        [106.794770801831, 47.9081576969202],
        [106.791247879486, 47.9078693544871],
        [106.78969297595, 47.9077185354821],
        [106.788383063028, 47.9075914621763],
        [106.78608333288, 47.9073888889861],
        [106.785971592115, 47.9067705861937],
        [106.785904196022, 47.9054866106186],
        [106.785904135767, 47.9054830007399],
        [106.785903950507, 47.9054794718002],
        [106.785882090686, 47.9041704680927],
        [106.785826090801, 47.9027669015713],
        [106.785724638281, 47.9009423893798],
        [106.785724439531, 47.9009360986221],
        [106.785724392767, 47.9009352505614],
        [106.785639418524, 47.8982403852856],
        [106.785555621495, 47.8960286214238],
        [106.785555557643, 47.8960262777905],
        [106.78555537598, 47.8960214826054],
        [106.785529727315, 47.8950798771347],
        [106.785441784411, 47.8931039721706],
        [106.785441538896, 47.8930968342515],
        [106.785373433237, 47.8911161376997],
        [106.78529511218, 47.8893455389655],
        [106.785201128529, 47.8868652816075],
        [106.785116576969, 47.8849129002102],
        [106.785014852853, 47.882714374369],
        [106.784938974354, 47.8820291206475],
        [106.784841635333, 47.8812268606312],
        [106.784672404508, 47.8801089026038],
        [106.784433358413, 47.8784816045425],
        [106.784278098555, 47.8775159691867],
        [106.784234945486, 47.8765133887819],
        [106.78423496707, 47.8765124570843],
        [106.784234699971, 47.8765062508629],
        [106.784255781879, 47.8755965434458],
        [106.78430511419, 47.8738055471883],
        [106.784177215306, 47.8738030596635],
        [106.784056092814, 47.8737995046435],
        [106.783936739289, 47.8738016216476],
        [106.783812935918, 47.8738095491714],
        [106.783702086382, 47.8738218635882],
        [106.78359903217, 47.8738391278735],
        [106.783493160381, 47.8738627404732],
        [106.783397432945, 47.8738903730423],
        [106.783355716993, 47.8739049285696],
        [106.783317054239, 47.8739206873898],
        [106.783276564962, 47.8739396073271],
        [106.783233930801, 47.8739619132118],
        [106.783126648876, 47.874022606658],
        [106.782975078937, 47.8741157710261],
        [106.782811012918, 47.874220708419],
        [106.782743294867, 47.8742614719894],
        [106.78269657149, 47.8742868589514],
        [106.782631363447, 47.8743183729946],
        [106.782559690178, 47.8743560249107],
        [106.782530855215, 47.8743686990563],
        [106.782504513173, 47.874377374816],
        [106.782470994541, 47.8743932388569],
        [106.782415929052, 47.8744285048717],
        [106.782393277828, 47.8744412167888],
        [106.782324976117, 47.8744712208702],
        [106.782244812348, 47.8744991475177],
        [106.782152077856, 47.8745255758947],
        [106.782017755115, 47.8745587671734],
        [106.781926586343, 47.8745796062639],
        [106.781842354041, 47.8745964892366],
        [106.781763000562, 47.8746098279812],
        [106.781687735401, 47.8746197511007],
        [106.781618948056, 47.8746249213031],
        [106.78154250838, 47.8746257441828],
        [106.78145795592, 47.8746225488916],
        [106.781283017997, 47.8746108900806],
        [106.781208113464, 47.8746072271419],
        [106.781129649414, 47.8746064123561],
        [106.78105977299, 47.8746096265331],
        [106.780954867973, 47.8746195910214],
        [106.780857628777, 47.8746258008401],
        [106.78054972519, 47.8746408923633],
        [106.78044828526, 47.8746443655451],
        [106.780369430005, 47.8746453341149],
        [106.780289350773, 47.87464413352],
        [106.78020261296, 47.8746397556202],
        [106.780111154606, 47.8746321716375],
        [106.780022319574, 47.8746222898868],
        [106.779936045812, 47.8746092919853],
        [106.779841109779, 47.8745902425457],
        [106.779753272096, 47.8745689564922],
        [106.779687804149, 47.874548522996],
        [106.77963791246, 47.8745278673672],
        [106.779585580011, 47.8745001466645],
        [106.779525507097, 47.8744618049684],
        [106.779473438149, 47.8744234884533],
        [106.779403920555, 47.8743607319623],
        [106.779355767255, 47.874312576864],
        [106.779304174948, 47.8742565904693],
        [106.779245662357, 47.8741877545613],
        [106.779139322921, 47.8740497535933],
        [106.779065568621, 47.8739613304511],
        [106.778967392331, 47.8738565135673],
        [106.778859369364, 47.8737492586214],
        [106.778731939028, 47.8736288843656],
        [106.778531695082, 47.8734442175766],
        [106.778381864432, 47.8732981146164],
        [106.778313721901, 47.8732369400328],
        [106.778267177488, 47.8731990129241],
        [106.778206233131, 47.8731543678798],
        [106.778132336738, 47.8731048404161],
        [106.778073976133, 47.8730693144973],
        [106.778025104275, 47.8730428258657],
        [106.777976227021, 47.8730194758681],
        [106.777919994212, 47.8729961672394],
        [106.777862971799, 47.8729754414635],
        [106.777797577596, 47.8729545628029],
        [106.777725021193, 47.8729343631304],
        [106.77765325979, 47.8729168119614],
        [106.777581708829, 47.8729018454439],
        [106.777515237238, 47.8728902738671],
        [106.777439452269, 47.8728796402832],
        [106.777355987989, 47.8728704123397],
        [106.777273195502, 47.8728631781932],
        [106.77719332761, 47.8728580691446],
        [106.777119006737, 47.8728550797982],
        [106.777034672812, 47.8728538522236],
        [106.776953768901, 47.8728544853463],
        [106.776791021289, 47.8728601681623],
        [106.776628698156, 47.872870547238],
        [106.776493030029, 47.8728839516331],
        [106.776375974272, 47.8729007347811],
        [106.776266088809, 47.8729222699468],
        [106.776149827153, 47.8729512101303],
        [106.776031408023, 47.8729866236338],
        [106.775901577396, 47.8730315025019],
        [106.775815397163, 47.8730646533111],
        [106.775730098265, 47.8731012386313],
        [106.775661129258, 47.8731342662335],
        [106.775579388978, 47.8731774858524],
        [106.775428301975, 47.8732646310579],
        [106.775170288278, 47.8734193962882],
        [106.774964175356, 47.8735478077851],
        [106.774886605233, 47.8735921002952],
        [106.77480419136, 47.873634082447],
        [106.774725819041, 47.87367038538],
        [106.774641871825, 47.8737065947836],
        [106.774455855154, 47.873779992053],
        [106.77426652538, 47.8738473800526],
        [106.774086215806, 47.8739040346435],
        [106.773907504328, 47.8739545045968],
        [106.77367571756, 47.8740147888515],
        [106.773464542355, 47.8740656113389],
        [106.773259821584, 47.8741102653765],
        [106.772964840355, 47.8741713059611],
        [106.772551587486, 47.8742525552113],
        [106.772269120324, 47.8743068490818],
        [106.772018008924, 47.8743505282544],
        [106.771792683785, 47.8743834425419],
        [106.771627186945, 47.8744026979262],
        [106.77146354001, 47.8744169872542],
        [106.77125111115, 47.8744309672154],
        [106.771098803767, 47.874437109585],
        [106.770978080574, 47.8744379828267],
        [106.770863024009, 47.8744343576595],
        [106.770737720569, 47.8744258995357],
        [106.770588762262, 47.8744120841504],
        [106.770098273816, 47.874363331003],
        [106.769919348299, 47.8743442419932],
        [106.769737327316, 47.8743214639645],
        [106.769583000055, 47.8742979961556],
        [106.769476096745, 47.8742791373724],
        [106.769352064047, 47.8742548071137],
        [106.769235687277, 47.8742299399598],
        [106.769107085124, 47.8742003576604],
        [106.768973189561, 47.8741644828047],
        [106.768792082289, 47.8741085197924],
        [106.768731198186, 47.8740922816335],
        [106.768687407498, 47.8740822640852],
        [106.768621749794, 47.8740701286336],
        [106.768542047378, 47.8740590858582],
        [106.768461394378, 47.8740508759472],
        [106.768375124213, 47.8740446112698],
        [106.768222793447, 47.8740380174406],
        [106.768039173469, 47.8740349264707],
        [106.767898139987, 47.8740367475979],
        [106.767762391821, 47.8740430023827],
        [106.767630624953, 47.8740540604466],
        [106.767496612479, 47.8740706385492],
        [106.767361088244, 47.8740925927989],
        [106.767228872614, 47.8741190490549],
        [106.767143128553, 47.8741389168775],
        [106.76706034326, 47.8741602568904],
        [106.766977620021, 47.8741838506043],
        [106.766896831224, 47.8742091710165],
        [106.766747504194, 47.8742617984433],
        [106.766601755567, 47.874318871219],
        [106.766542228541, 47.8743437374736],
        [106.766492149793, 47.8743670344111],
        [106.766454336898, 47.8743873402037],
        [106.766411816053, 47.874413228088],
        [106.766367213276, 47.8744437924471],
        [106.766333548954, 47.8744698664912],
        [106.766304422611, 47.8744957714628],
        [106.76627875596, 47.8745230011356],
        [106.766258777521, 47.8745491399309],
        [106.766231634183, 47.8745948021085],
        [106.766210120601, 47.8746372582029],
        [106.766195526402, 47.8746733156211],
        [106.766184578955, 47.8747111006368],
        [106.766183425125, 47.874745775797],
        [106.766186445048, 47.8747679800583],
        [106.766192650371, 47.8747916565098],
        [106.766210948876, 47.8748337258958],
        [106.766237108356, 47.8748759985286],
        [106.766302516948, 47.8749648092786],
        [106.766317793731, 47.8749909282888],
        [106.766324592606, 47.8750070873073],
        [106.76632893813, 47.8750282321672],
        [106.766330324885, 47.8750595969229],
        [106.766328821218, 47.8751215620105],
        [106.766321251625, 47.8751968775339],
        [106.766309065811, 47.8752732524587],
        [106.766292457131, 47.8753468062102],
        [106.766255054327, 47.8754758733129],
        [106.76623146511, 47.875565957503],
        [106.766213783539, 47.875621433982],
        [106.766196114559, 47.8756606902887],
        [106.766176379836, 47.8756918562942],
        [106.766150051284, 47.8757219251268],
        [106.766115034381, 47.8757544563032],
        [106.766078478739, 47.8757817965927],
        [106.766058583037, 47.8757935336447],
        [106.766041050754, 47.875801716576],
        [106.765992124037, 47.8758184097918],
        [106.765917242887, 47.8758372712731],
        [106.765852512384, 47.8758558755483],
        [106.76577571118, 47.8758813659323],
        [106.765742221326, 47.8758942298349],
        [106.76571382883, 47.8759070910395],
        [106.765644858923, 47.8759450433291],
        [106.765608757438, 47.8759682332474],
        [106.765575973552, 47.8759918305586],
        [106.765522674332, 47.8760371375039],
        [106.765478511324, 47.8760807744083],
        [106.765361532908, 47.8762061102238],
        [106.765321685747, 47.8762441722308],
        [106.76528703307, 47.8762727679739],
        [106.765226005975, 47.8763169022033],
        [106.765161828556, 47.8763569580073],
        [106.765100394967, 47.8763898713955],
        [106.765027344836, 47.8764229169841],
        [106.764958513425, 47.8764501061875],
        [106.764884206941, 47.8764759967699],
        [106.764820713006, 47.8764949670691],
        [106.764741073542, 47.8765156307918],
        [106.764571147541, 47.8765553007865],
        [106.76438584583, 47.8765952001084],
        [106.764302559615, 47.8766112925771],
        [106.76410146581, 47.8766468562675],
        [106.763985915518, 47.8766705785844],
        [106.76389975417, 47.8766913520244],
        [106.763746364004, 47.8767329852391],
        [106.763644672264, 47.8767657844135],
        [106.763603043546, 47.8767819299422],
        [106.763565189282, 47.8767989909807],
        [106.763525641595, 47.8768192149349],
        [106.763486636199, 47.8768417582406],
        [106.763393350423, 47.8769031153865],
        [106.763263206832, 47.8769926330037],
        [106.763136523832, 47.8770844780662],
        [106.76302568149, 47.8771689729698],
        [106.762964694865, 47.8772210383203],
        [106.762904190276, 47.8772771182445],
        [106.762849931479, 47.8773314220076],
        [106.762804700976, 47.8773818748737],
        [106.762775517077, 47.8774188163254],
        [106.762747728025, 47.8774591329327],
        [106.762715374015, 47.8775131624026],
        [106.762686587616, 47.8775667574999],
        [106.762633050075, 47.877675138397],
        [106.762593262269, 47.8777610092632],
        [106.762501148309, 47.8779835599934],
        [106.762464870557, 47.8780635438975],
        [106.762425711378, 47.8781407497958],
        [106.762374046225, 47.8782224460091],
        [106.762325606042, 47.8782890497999],
        [106.762278591284, 47.878347492243],
        [106.762229854324, 47.8784021746207],
        [106.762175988531, 47.8784563371902],
        [106.762124023005, 47.8785026091082],
        [106.762069162562, 47.8785460301752],
        [106.762005993282, 47.8785910268544],
        [106.76193764031, 47.8786353868137],
        [106.761866287199, 47.8786782323146],
        [106.761781068342, 47.8787262399241],
        [106.761688194455, 47.8787761675861],
        [106.761592820452, 47.8788250115651],
        [106.761445843351, 47.8788958097939],
        [106.761289258792, 47.8789636150788],
        [106.761111933169, 47.8790324851611],
        [106.760925013579, 47.8790972759186],
        [106.760753411241, 47.8791495732942],
        [106.760567309134, 47.8791984946149],
        [106.760455080937, 47.8792248375562],
        [106.760336169878, 47.8792505563682],
        [106.760210350228, 47.87927595682],
        [106.760071607319, 47.879301879778],
        [106.759897680234, 47.8793329081872],
        [106.759754804041, 47.8793566080211],
        [106.759599790598, 47.8793800074814],
        [106.759478431584, 47.8793959173877],
        [106.759370933822, 47.8794076724262],
        [106.759270042479, 47.8794163418907],
        [106.759187362407, 47.8794214545365],
        [106.759063119268, 47.8794265554912],
        [106.758944905183, 47.8794292480614],
        [106.758865454577, 47.8794290780895],
        [106.75878963993, 47.879426407103],
        [106.758718453194, 47.8794209374264],
        [106.758656197626, 47.8794133615374],
        [106.758596301878, 47.8794039321458],
        [106.758531571375, 47.8793918650426],
        [106.758441834323, 47.879372874059],
        [106.758336040776, 47.8793488225901],
        [106.758243632738, 47.8793259366427],
        [106.758086426747, 47.8792821099814],
        [106.757866084752, 47.8792127560639],
        [106.757643175192, 47.8791368532832],
        [106.757455712411, 47.8790669831548],
        [106.757250254196, 47.8789848120995],
        [106.757068909503, 47.8789093634764],
        [106.756921552887, 47.8788457975956],
        [106.756782102212, 47.8787832839214],
        [106.756660377175, 47.8787254611112],
        [106.756524035456, 47.8786576828058],
        [106.756341903856, 47.8785635732503],
        [106.755842929408, 47.8782997121621],
        [106.755660684493, 47.8782079309513],
        [106.755492774772, 47.8781280522679],
        [106.755295922169, 47.8780403602744],
        [106.755085098598, 47.8779514838739],
        [106.754811393531, 47.8778410426301],
        [106.754407161761, 47.8776822844099],
        [106.754151744408, 47.8775801951699],
        [106.75393051658, 47.8774885065894],
        [106.753745710396, 47.8774078194154],
        [106.753432228315, 47.8772644827697],
        [106.753242813105, 47.877175066776],
        [106.753090697278, 47.8771009878204],
        [106.7529057499, 47.8770072640741],
        [106.752685205558, 47.8768869221938],
        [106.752607074257, 47.8768460785837],
        [106.752494022281, 47.8767901092762],
        [106.752378759772, 47.8767375834727],
        [106.752247939891, 47.8766816141652],
        [106.752130250111, 47.8766341443504],
        [106.752005753363, 47.8765873571209],
        [106.751888381044, 47.8765466556037],
        [106.751769812627, 47.8765089200507],
        [106.751650582309, 47.8764744058692],
        [106.751523727538, 47.8764409852633],
        [106.751392323997, 47.8764096564805],
        [106.751210431616, 47.8763714469848],
        [106.75101304032, 47.8763360172934],
        [106.750825032549, 47.8763077704872],
        [106.750649591905, 47.8762872173812],
        [106.750556057916, 47.8762789741954],
        [106.750459624512, 47.8762723515878],
        [106.750365184905, 47.8762674592759],
        [106.750285053512, 47.8762649852409],
        [106.750144945433, 47.8762651462196],
        [106.749999856908, 47.8762725818142],
        [106.749872270089, 47.876284630931],
        [106.749741080586, 47.8763019941418],
        [106.749607581625, 47.8763245698231],
        [106.749477133163, 47.8763513992977],
        [106.749387668606, 47.8763740945889],
        [106.749287413983, 47.8764043990438],
        [106.749025072749, 47.8764943168593],
        [106.74885121761, 47.8765504381523],
        [106.74874737739, 47.8765878922175],
        [106.748682027254, 47.8766082924388],
        [106.748634156341, 47.8766194818037],
        [106.748583128808, 47.876626578354],
        [106.748527808811, 47.8766291315292],
        [106.748466041575, 47.8766279669072],
        [106.748397624751, 47.8766232337752],
        [106.748345897545, 47.876616564403],
        [106.748284212147, 47.8766056007679],
        [106.748152626942, 47.8765767532146],
        [106.748087040285, 47.8765656915535],
        [106.74797533999, 47.8765498185194],
        [106.747826781881, 47.8765296961886],
        [106.747643847186, 47.8765072652981],
        [106.747350363329, 47.8764750452872],
        [106.747181637023, 47.8764597712016],
        [106.747007303444, 47.8764471096465],
        [106.746441989606, 47.8764149058233],
        [106.746179454119, 47.8763970929515],
        [106.745917128173, 47.8763770092916],
        [106.745617076567, 47.876351615135],
        [106.745327499365, 47.8763247865597],
        [106.745047089851, 47.8762968626102],
        [106.744833551227, 47.8762721069722],
        [106.744650797297, 47.8762480689932],
        [106.74451666791, 47.8762284224038],
        [106.744399601361, 47.8762087074659],
        [106.744286551183, 47.876185889867],
        [106.744158852849, 47.8761560476635],
        [106.744048900836, 47.8761265552964],
        [106.743923458901, 47.8760872935938],
        [106.743817636575, 47.8760506408245],
        [106.74376917211, 47.8760315751971],
        [106.743730785447, 47.8760144431121],
        [106.743695664224, 47.8759965340129],
        [106.743661254363, 47.8759761742611],
        [106.743594379877, 47.8759290551818],
        [106.743551858132, 47.875895550939],
        [106.74349747343, 47.8758492781217],
        [106.743414864405, 47.875774254878],
        [106.74334002732, 47.8756960129607],
        [106.74328461919, 47.8756272489984],
        [106.74323246031, 47.8755492543946],
        [106.743185314251, 47.8754715961373],
        [106.743119465891, 47.8753540124778],
        [106.743055359517, 47.8752355663684],
        [106.742987492179, 47.875095922339],
        [106.742925535185, 47.8749522871184],
        [106.742888413869, 47.8748530945947],
        [106.742844758978, 47.8747177628146],
        [106.742775991419, 47.8744820603988],
        [106.742727822831, 47.8743063868304],
        [106.74270153205, 47.8742214476617],
        [106.742676306067, 47.8741521216232],
        [106.74263158458, 47.8740474288458],
        [106.74258979938, 47.8739662326556],
        [106.742547028523, 47.8739014041266],
        [106.742485285568, 47.8738264195537],
        [106.742436375938, 47.8737720456434],
        [106.742375942396, 47.8737090454362],
        [106.742294388275, 47.8736288861642],
        [106.742205259165, 47.8735475379885],
        [106.742093847553, 47.8734522242408],
        [106.741991131486, 47.8733694605322],
        [106.741900312549, 47.873301093171],
        [106.741815078403, 47.8732417586003],
        [106.741735214109, 47.8731907472553],
        [106.741649376518, 47.873141316019],
        [106.741555784972, 47.8730925538783],
        [106.741442750083, 47.8730384596573],
        [106.741146669883, 47.8729067656348],
        [106.741015118853, 47.8728463159048],
        [106.740932945099, 47.8728118143138],
        [106.740861759263, 47.8727866018203],
        [106.740780531596, 47.8727634604654],
        [106.740690644358, 47.8727425620196],
        [106.740574779303, 47.8727200879617],
        [106.740430088278, 47.8726951623519],
        [106.740342337829, 47.8726815556093],
        [106.740262987947, 47.8726714283438],
        [106.7401957951, 47.8726653228464],
        [106.740116125059, 47.8726613793192],
        [106.740027283732, 47.8726605564396],
        [106.739945402259, 47.8726630241793],
        [106.739860916348, 47.8726689588054],
        [106.739775148904, 47.8726776714374],
        [106.739714378116, 47.872686388566],
        [106.739660412498, 47.8726974376367],
        [106.739610449762, 47.8727114265911],
        [106.739551534276, 47.8727324914114],
        [106.739492361583, 47.8727585177914],
        [106.739435415612, 47.8727884957925],
        [106.739384472615, 47.8728205934956],
        [106.739339541587, 47.8728542740056],
        [106.739295455921, 47.872892672359],
        [106.739265057936, 47.8729232744896],
        [106.739231495237, 47.8729631971938],
        [106.739184279031, 47.8730263305008],
        [106.739123860778, 47.8731173266034],
        [106.73904342991, 47.8732492841272],
        [106.738974780162, 47.8733717735885],
        [106.738901448543, 47.8735087808057],
        [106.738856095732, 47.8735986680442],
        [106.738802756942, 47.8737109493009],
        [106.73871382928, 47.8739047055378],
        [106.738646703882, 47.874060825147],
        [106.738612154627, 47.8741465341353],
        [106.738565634496, 47.8742798811117],
        [106.738541959844, 47.8743339177761],
        [106.738522474233, 47.874369044396],
        [106.73849914492, 47.8744034884303],
        [106.738470789296, 47.8744381438053],
        [106.738437436139, 47.8744739656011],
        [106.738384140516, 47.8745247170421],
        [106.738307386976, 47.874591014164],
        [106.738233657857, 47.8746497524841],
        [106.738162441444, 47.8747012638523],
        [106.738058451936, 47.8747699046075],
        [106.737905103138, 47.8748637119908],
        [106.737823244147, 47.8749113490795],
        [106.737760661226, 47.8749435358156],
        [106.737701720558, 47.8749687680942],
        [106.737637333596, 47.8749913437755],
        [106.737565742165, 47.8750123222609],
        [106.737488431046, 47.875031035354],
        [106.737424123225, 47.8750436177688],
        [106.73734766916, 47.875055335935],
        [106.737246455859, 47.8750671152552],
        [106.73715882502, 47.875075076054],
        [106.73705583376, 47.8750809917944],
        [106.736936116009, 47.8750832769717],
        [106.736795373907, 47.875081605132],
        [106.73665412189, 47.8750761012811],
        [106.736549993887, 47.8750694292108],
        [106.736441252362, 47.87505956095],
        [106.736197576557, 47.8750315785446],
        [106.736085261126, 47.8750209422627],
        [106.735769360767, 47.8749947081393],
        [106.735423407764, 47.8749713446519],
        [106.735305807017, 47.8749644765294],
        [106.73522436801, 47.8749616526582],
        [106.735116828879, 47.8749607713226],
        [106.734997030189, 47.8749625142087],
        [106.73483865508, 47.8749679128389],
        [106.734697901287, 47.8749758538526],
        [106.734571963825, 47.8749860062992],
        [106.734418724744, 47.8750019467824],
        [106.734157215383, 47.8750344698649],
        [106.733804521062, 47.8750820008337],
        [106.733393584846, 47.8751418075485],
        [106.733218637031, 47.8751653787793],
        [106.732940248294, 47.8752003030516],
        [106.732736085102, 47.8752206592061],
        [106.732619824345, 47.8752283358191],
        [106.732494457054, 47.8752338153883],
        [106.732385782078, 47.8752364126304],
        [106.7322796315, 47.8752363829528],
        [106.732170836015, 47.8752331543866],
        [106.73206201445, 47.8752269913326],
        [106.731958921567, 47.8752185413027],
        [106.731862534029, 47.875207575869],
        [106.731748847132, 47.8751894824088],
        [106.731626708406, 47.8751630486358],
        [106.731468087782, 47.8751250199038],
        [106.731286373467, 47.8750771328035],
        [106.731148157562, 47.8750382757958],
        [106.73100010577, 47.8749913779498],
        [106.730927123988, 47.8749660926112],
        [106.73087505414, 47.8749462400769],
        [106.730832920003, 47.8749284811645],
        [106.730789570882, 47.8749078992802],
        [106.730712908174, 47.8748644674213],
        [106.730666706403, 47.8748340568463],
        [106.73062090573, 47.8748009599964],
        [106.730571596802, 47.8747626731589],
        [106.730522492919, 47.8747216272014],
        [106.730484928237, 47.8746881400457],
        [106.730455245213, 47.8746587888721],
        [106.730430476985, 47.8746307372188],
        [106.730410504841, 47.8746040921052],
        [106.730392762116, 47.874575901057],
        [106.730375587763, 47.8745435218661],
        [106.730356525733, 47.8745021665418],
        [106.730342605127, 47.874464914824],
        [106.730327766313, 47.8744070938124],
        [106.730314959967, 47.8743144834267],
        [106.730303816468, 47.8742751461811],
        [106.730291177396, 47.8742431554973],
        [106.730262032167, 47.8741868300582],
        [106.730232811395, 47.8741404565169],
        [106.73020031799, 47.8740982072665],
        [106.730162424157, 47.874058255784],
        [106.730118343887, 47.8740212432858],
        [106.73006160386, 47.8739819555029],
        [106.729980451737, 47.8739329685317],
        [106.729898443458, 47.8738893352247],
        [106.729815994513, 47.8738514404916],
        [106.729713982614, 47.8738097218413],
        [106.729614240605, 47.8737730942529],
        [106.729515716277, 47.8737411773135],
        [106.729386520572, 47.8737048204211],
        [106.729252996429, 47.8736708800072],
        [106.729188497052, 47.8736563280771],
        [106.729136811215, 47.8736466369827],
        [106.729088814397, 47.8736401744545],
        [106.729041046907, 47.8736367750172],
        [106.728993456583, 47.8736360330765],
        [106.728915453885, 47.8736377831572],
        [106.728803275151, 47.8736423391227],
        [106.728654642398, 47.8736509636211],
        [106.728536704405, 47.8736589334131],
        [106.728437287051, 47.8736677584603],
        [106.728342404079, 47.8736782850249],
        [106.728197666289, 47.873696841636],
        [106.728088126166, 47.8737122533179],
        [106.72783762001, 47.8737507550933],
        [106.727719406825, 47.8737666191342],
        [106.727587741581, 47.8737814993168],
        [106.727494333497, 47.8737909026281],
        [106.727434301952, 47.873795213978],
        [106.727345867118, 47.8737977042007],
        [106.727305293305, 47.8737958974627],
        [106.72726698938, 47.8737920645522],
        [106.727220471947, 47.8737850363504],
        [106.727173036307, 47.8737755458049],
        [106.727126441532, 47.8737640254894],
        [106.727078541841, 47.8737500095554],
        [106.72703395885, 47.8737344009219],
        [106.726992410172, 47.8737170745834],
        [106.72694768149, 47.8736953190838],
        [106.726892785074, 47.8736654292163],
        [106.726799527177, 47.8736107603284],
        [106.726744473379, 47.8735763010055],
        [106.726694047492, 47.8735414621688],
        [106.726653479974, 47.8735094975653],
        [106.726619495493, 47.8734788189923],
        [106.726585352732, 47.8734437256475],
        [106.72655472632, 47.8734079901866],
        [106.726526845538, 47.8733709318231],
        [106.726501852479, 47.8733326746632],
        [106.726481120407, 47.8732956082058],
        [106.726463879504, 47.8732581298589],
        [106.726449529023, 47.8732189724777],
        [106.726435845838, 47.8731723965889],
        [106.726424258073, 47.873120838456],
        [106.726416187557, 47.8730702452957],
        [106.72641098318, 47.8730182366024],
        [106.726408724083, 47.8729611134647],
        [106.726409457031, 47.8729016961564],
        [106.726412930213, 47.872851236995],
        [106.726420102306, 47.8727930508587],
        [106.726430556025, 47.8727302565961],
        [106.726444765314, 47.8726620601061],
        [106.726473204575, 47.8725522645754],
        [106.726503647525, 47.8724560263246],
        [106.72658743736, 47.8722210091923],
        [106.726613483526, 47.8721421962055],
        [106.726638353377, 47.8720610045118],
        [106.726651610284, 47.8720102170979],
        [106.726668941119, 47.8719157469142],
        [106.726680239302, 47.871817156037],
        [106.72668127622, 47.871743637359],
        [106.726673658962, 47.8716809636056],
        [106.726654024963, 47.8716045068426],
        [106.726633127417, 47.8715364659352],
        [106.726594976377, 47.8714257800757],
        [106.726514273915, 47.871202535069],
        [106.726470123497, 47.8710718581798],
        [106.726423210363, 47.8709208395252],
        [106.726370190832, 47.8707354218023],
        [106.726323800203, 47.8705533333697],
        [106.726302870281, 47.8704799630799],
        [106.726276914048, 47.8704007822703],
        [106.726251158364, 47.8703399341407],
        [106.726211986594, 47.8702673111875],
        [106.72616227387, 47.8701897563522],
        [106.726093700564, 47.8700943850479],
        [106.725994999969, 47.8699659303834],
        [106.725926147874, 47.8698822961311],
        [106.725858156429, 47.8698059185084],
        [106.725789163139, 47.8697349781867],
        [106.725715355779, 47.8696652735336],
        [106.725636717261, 47.8695964879876],
        [106.725556217146, 47.8695314409233],
        [106.725476585776, 47.8694724301086],
        [106.725392894866, 47.8694153870106],
        [106.725291588036, 47.8693512824358],
        [106.725171576207, 47.8692800048684],
        [106.725025902224, 47.8691971026642],
        [106.724899246203, 47.8691297272551],
        [106.724825704143, 47.8690941096055],
        [106.724751603604, 47.869061480403],
        [106.724669580936, 47.8690291272924],
        [106.72458746384, 47.8689997923066],
        [106.724492649216, 47.8689687917764],
        [106.72437894793, 47.8689344898349],
        [106.724253645389, 47.8688994288656],
        [106.72414330397, 47.8688710462618],
        [106.724053028225, 47.8688498276575],
        [106.723963462944, 47.8688306649033],
        [106.723874705253, 47.8688137090855],
        [106.723788187775, 47.868799161652],
        [106.723695656529, 47.8687856916064],
        [106.723602539825, 47.8687741362174],
        [106.723508888025, 47.8687643902645],
        [106.723406943576, 47.8687557091088],
        [106.723289662988, 47.8687487231751],
        [106.723190580181, 47.8687470675232],
        [106.7230779338, 47.8687495352629],
        [106.722883947336, 47.8687593153902],
        [106.722775970235, 47.8687631554953],
        [106.722694543818, 47.8687640925888],
        [106.722626157571, 47.8687626150027],
        [106.722502172537, 47.8687542620996],
        [106.722418853048, 47.8687466232581],
        [106.722209355977, 47.8687241294151],
        [106.721889961752, 47.868696700992],
        [106.721738963782, 47.8686790643874],
        [106.721589543223, 47.8686565516586],
        [106.721494326602, 47.8686401624136],
        [106.72144087, 47.8686285359782],
        [106.721395643994, 47.8686160174153],
        [106.721353508957, 47.8686016129741],
        [106.721306608413, 47.8685823818715],
        [106.721253967497, 47.8685571711766],
        [106.721204123472, 47.8685298012094],
        [106.721151116531, 47.8684970029344],
        [106.72110356128, 47.8684637280187],
        [106.721064176371, 47.8684325395301],
        [106.721023468558, 47.8683960684239],
        [106.720978281223, 47.8683506535598],
        [106.720944120475, 47.8683123280516],
        [106.720894580421, 47.8682461964049],
        [106.720791513618, 47.8680872556224],
        [106.720623842217, 47.8678500810164],
        [106.720563002181, 47.8677608520817],
        [106.720501096449, 47.8676639609231],
        [106.720423833893, 47.8675282891992],
        [106.720368657787, 47.8674398480706],
        [106.720339472988, 47.8673989765816],
        [106.72031259585, 47.8673652771859],
        [106.720285153037, 47.8673345158752],
        [106.720250143329, 47.8672996815351],
        [106.720179289343, 47.8672358494549],
        [106.720121115797, 47.8671892798614],
        [106.720063811895, 47.8671501323728],
        [106.720005606873, 47.8671172207831],
        [106.719932383173, 47.8670831112966],
        [106.719846152578, 47.8670498183944],
        [106.71974765523, 47.8670179311327],
        [106.719648992407, 47.8669917302841],
        [106.719567099242, 47.8669743454897],
        [106.719476506935, 47.8669591793227],
        [106.719380396388, 47.8669470789446],
        [106.719286320108, 47.8669387044577],
        [106.719202608514, 47.866934670099],
        [106.719121034608, 47.8669339011786],
        [106.719023553494, 47.8669368464584],
        [106.71892961481, 47.8669427675947],
        [106.718812822554, 47.8669527941362],
        [106.718699040328, 47.8669653558665],
        [106.718598376514, 47.8669789383274],
        [106.718501234444, 47.8669950766615],
        [106.718393742078, 47.8670155964927],
        [106.718255522574, 47.8670451572083],
        [106.718092997094, 47.8670823810471],
        [106.717934547342, 47.8671213639598],
        [106.717731887816, 47.8671753079941],
        [106.717559298923, 47.8672275181355],
        [106.717474752758, 47.8672559295176],
        [106.717401877095, 47.8672823524986],
        [106.71726487977, 47.8673381374451],
        [106.717135607622, 47.867398276909],
        [106.716975428473, 47.8674793013287],
        [106.716757207979, 47.8675917480608],
        [106.716560762769, 47.8676954371947],
        [106.716316596834, 47.8678281258674],
        [106.716093689073, 47.8679563539027],
        [106.715893199612, 47.8680797498806],
        [106.715661094484, 47.8682304115043],
        [106.71553864819, 47.868313507962],
        [106.715449501993, 47.8683766475643],
        [106.715309646623, 47.8684823116095],
        [106.715186567206, 47.8685852668966],
        [106.715123222559, 47.8686424808658],
        [106.715056799532, 47.8687056492464],
        [106.714935041219, 47.8688299805193],
        [106.714836405376, 47.8689406663787],
        [106.714722410011, 47.8690796871779],
        [106.714638598593, 47.869191142857],
        [106.714571833823, 47.8692927779394],
        [106.714538839496, 47.8693511160612],
        [106.714514641438, 47.8694029547826],
        [106.714491882295, 47.8694602550868],
        [106.714458237758, 47.8695633884397],
        [106.714437932864, 47.8696176841089],
        [106.714415565826, 47.8696707504049],
        [106.714382484264, 47.8697394837902],
        [106.71433956412, 47.8698222250157],
        [106.714293266121, 47.8699046343914],
        [106.714229861219, 47.8700108065535],
        [106.714165044381, 47.8701121538529],
        [106.714102384118, 47.8702039665399],
        [106.714036162539, 47.8702880495539],
        [106.713956456525, 47.8703727000401],
        [106.713908893181, 47.8704185591692],
        [106.713865107888, 47.8704576311148],
        [106.713819441214, 47.8704950914753],
        [106.713778653362, 47.8705251899856],
        [106.713730606183, 47.8705563416019],
        [106.7136788484, 47.8705863555759],
        [106.713617560502, 47.8706180998455],
        [106.713563468979, 47.8706431999238],
        [106.713506009495, 47.8706660633882],
        [106.713453621288, 47.8706831289233],
        [106.713407313397, 47.8706951681476],
        [106.713359629543, 47.8707043619168],
        [106.713308950048, 47.8707114036084],
        [106.713249185602, 47.8707168382116],
        [106.713177765042, 47.8707202646286],
        [106.713111424753, 47.8707211603533],
        [106.713044317341, 47.8707194534401],
        [106.712982916129, 47.870715239217],
        [106.712900442901, 47.8707059923877],
        [106.712801531865, 47.870690938636],
        [106.712695316536, 47.8706714602197],
        [106.712604270071, 47.8706519539246],
        [106.712509100215, 47.8706280094751],
        [106.712398646381, 47.8705968074967],
        [106.712297496932, 47.8705653609027],
        [106.712197868237, 47.8705311794704],
        [106.712088922566, 47.8704902144519],
        [106.712002124498, 47.870454059907],
        [106.71183971593, 47.8703822760213],
        [106.711609406749, 47.8702743924493],
        [106.711519302774, 47.8702315100762],
        [106.711452356341, 47.8701976002391],
        [106.711366915351, 47.8701514668168],
        [106.711288605085, 47.8701066931694],
        [106.711179679199, 47.8700408753862],
        [106.711053137392, 47.8699601270583],
        [106.710930933916, 47.869879464166],
        [106.710789231338, 47.8697830928155],
        [106.710590546816, 47.8696406438007],
        [106.710475380534, 47.8695544329908],
        [106.710364318758, 47.8694685261516],
        [106.710220454211, 47.8693528274711],
        [106.710105285231, 47.8692531106426],
        [106.709953031807, 47.8691129423085],
        [106.709657965143, 47.8688344519484],
        [106.709572167122, 47.8687570302128],
        [106.709484634308, 47.8686815501135],
        [106.709365117107, 47.8685853163593],
        [106.709244870554, 47.8684934146394],
        [106.709071263628, 47.8683659843028],
        [106.708920500381, 47.8682597159132],
        [106.708736545855, 47.8681364656255],
        [106.708544429982, 47.8680157613184],
        [106.708336986063, 47.867891970538],
        [106.708124846784, 47.8677723759944],
        [106.707958593614, 47.8676855878197],
        [106.70780294525, 47.8676110969746],
        [106.707640952168, 47.867540949855],
        [106.707462324327, 47.8674705014625],
        [106.707332760798, 47.8674228499846],
        [106.707199439902, 47.867376157184],
        [106.707069597584, 47.8673326956474],
        [106.706938112204, 47.8672909581112],
        [106.706820166118, 47.8672556111576],
        [106.706710314829, 47.8672247005595],
        [106.706522338535, 47.8671736856172],
        [106.706410449383, 47.8671464892192],
        [106.706343950813, 47.8671327520749],
        [106.706275034865, 47.8671210617876],
        [106.706191192869, 47.8671098814159],
        [106.706114227989, 47.8671018315843],
        [106.705961054559, 47.8670890000574],
        [106.705903863972, 47.8670855655465],
        [106.705839476111, 47.8670848379949],
        [106.705779272795, 47.8670892905384],
        [106.705730927041, 47.8670963394246],
        [106.705680386041, 47.8671064945691],
        [106.705628750566, 47.8671196408588],
        [106.705578960501, 47.8671348573878],
        [106.705535075383, 47.8671508302467],
        [106.705494021332, 47.8671682968795],
        [106.705450397918, 47.8671896234025],
        [106.705405336487, 47.8672144788652],
        [106.705364393952, 47.8672393864886],
        [106.705327422822, 47.8672650540391],
        [106.705300667991, 47.8672863212068],
        [106.705263366811, 47.8673199333683],
        [106.705200292859, 47.867383560403],
        [106.705072598122, 47.8675263187846],
        [106.705025225434, 47.867575473929],
        [106.704979055139, 47.8676190919476],
        [106.704931882101, 47.8676541502189],
        [106.704890943163, 47.867679218821],
        [106.704837891256, 47.8677075249823],
        [106.704667672975, 47.8677932231787],
        [106.704487801371, 47.8678762315029],
        [106.704377191954, 47.8679238398134],
        [106.704268178833, 47.8679622876295],
        [106.70418275583, 47.8679877825102],
        [106.704108402581, 47.8680069524589],
        [106.704037902028, 47.8680218659164],
        [106.703971602208, 47.8680321424695],
        [106.703855639127, 47.868042962213],
        [106.703694206323, 47.8680517710724],
        [106.703534770014, 47.8680632320326],
        [106.703455158429, 47.8680671782577],
        [106.703379957119, 47.8680691819472],
        [106.703308201113, 47.8680687080045],
        [106.703225512048, 47.8680659965486],
        [106.703147635255, 47.868060937862],
        [106.703063108875, 47.8680521964517],
        [106.702981284059, 47.8680410169794],
        [106.702915695603, 47.8680294813755],
        [106.702860974554, 47.868017014074],
        [106.702784713844, 47.8679942675215],
        [106.702711273407, 47.8679665450201],
        [106.702649861402, 47.8679377208492],
        [106.702595939851, 47.8679052238471],
        [106.702529691292, 47.8678571658755],
        [106.702441273546, 47.8677845258352],
        [106.702392082429, 47.8677405175109],
        [106.702301131292, 47.8676508119354],
        [106.702236421474, 47.867595982069],
        [106.702182481037, 47.8675543659413],
        [106.702121738128, 47.8675108522441],
        [106.702083764254, 47.8674863807919],
        [106.702050733055, 47.8674678772408],
        [106.702004632008, 47.8674468402995],
        [106.701943505988, 47.8674262296369],
        [106.701872885825, 47.8674057152016],
        [106.701711727314, 47.8673660748845],
        [106.701641492961, 47.8673465506029],
        [106.701584726854, 47.867328664886],
        [106.70150150629, 47.8672990214328],
        [106.701399550149, 47.8672614972204],
        [106.701327977604, 47.8672332962797],
        [106.701254714334, 47.867201928826],
        [106.701219450118, 47.8671841681149],
        [106.701179812498, 47.8671616868624],
        [106.701105107615, 47.8671133563963],
        [106.701046721829, 47.8670685692591],
        [106.70099172199, 47.8670187621062],
        [106.700929461026, 47.8669535270836],
        [106.700878692498, 47.8668935764774],
        [106.7008131598, 47.866800838388],
        [106.700775256973, 47.8667418455598],
        [106.700682367797, 47.8665879742556],
        [106.700633548999, 47.8665123151913],
        [106.700590185489, 47.8664506252962],
        [106.700550173752, 47.8663981795324],
        [106.70051616319, 47.866357921381],
        [106.700481827075, 47.866321565388],
        [106.700446194137, 47.8662920703229],
        [106.700394506501, 47.8662585570868],
        [106.700335603605, 47.8662267417708],
        [106.70027683291, 47.8661998610348],
        [106.700210658995, 47.8661751278799],
        [106.700148068878, 47.8661547123701],
        [106.700010048125, 47.8661131511011],
        [106.699928299751, 47.8660900061489],
        [106.699841909976, 47.8660676930696],
        [106.699754333096, 47.8660471480575],
        [106.699667933428, 47.8660288711355],
        [106.699533174516, 47.8660043772003],
        [106.69939043592, 47.8659828294441],
        [106.699258845319, 47.8659678242557],
        [106.699079585255, 47.8659534063247],
        [106.698897374514, 47.8659342786441],
        [106.69877868289, 47.8659170530296],
        [106.69868623708, 47.8658978399134],
        [106.698626124596, 47.8658826000021],
        [106.698566620054, 47.8658654094612],
        [106.698507510313, 47.8658461981436],
        [106.698446960759, 47.8658243275307],
        [106.698390300772, 47.8658018579694],
        [106.698342671777, 47.8657807337939],
        [106.698302017924, 47.8657603443644],
        [106.698260977362, 47.865737011454],
        [106.698215844885, 47.8657080487875],
        [106.698179182224, 47.8656814180631],
        [106.698146709503, 47.8656540310088],
        [106.698122793832, 47.8656295982274],
        [106.698079196498, 47.8655725560287],
        [106.698047399168, 47.8655263074931],
        [106.698014874287, 47.8654744345976],
        [106.697984010454, 47.8654206533405],
        [106.697967159857, 47.8653841138858],
        [106.697949186906, 47.8653349416543],
        [106.697933942497, 47.865284555338],
        [106.69791792827, 47.8652204633537],
        [106.697897345486, 47.865117710414],
        [106.697888888262, 47.8650277782094],
        [106.675666667483, 47.873333332967],
        [106.650194445218, 47.8743333332168],
        [106.613472223065, 47.851277778147],
        [106.539722223302, 47.8476388891235],
        [106.519388889086, 47.8713611116261],
        [106.51602777726, 47.8898055565812],
        [106.533500000225, 47.9107222225526],
        [106.506611111014, 47.9461944455173],
        [106.527361111026, 47.9550833329295],
        [106.481055555769, 47.9807777785717],
        [106.459222222528, 48.0134166676452],
        [106.461111111788, 48.0419722218406],
        [106.477916666421, 48.072222221978],
        [106.426888888911, 48.1246944437936],
        [106.416194445218, 48.1338888893608],
        [106.428805556431, 48.1490277781095],
        [106.407750000962, 48.1966666673329],
        [106.367722222603, 48.2464444456547],
        [106.363138888949, 48.2572777779471],
        [106.441861110802, 48.272277778097],
        [106.453138889848, 48.2643333335166],
        [106.49900000015, 48.2538611114012],
        [106.589750000562, 48.2453611115261],
      ],
    ],
  },
};
